import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeBranchList } from './normalize';

export const fetchBranchList = createProvider(api.fetchBranchList)
  .andThen((res) => normalizeBranchList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch branch list aborted');
    } else {
      console.error('Fetch branch list was failed:', error);
    }
    throw error;
  });
